<template>
<span>
    <span
      v-tippy
      :title="`<b>${extraData}</b><br/> ${title}`"
      v-if="hasElipsis">
      {{extraData}}
    </span>
  <span
    v-tippy
    :title="title"
    v-else>
    {{extraData}}
  </span>
</template>

<script>
  export default {
    name: 'HasElipsis',
    props: ['title', 'extraData', 'element'],
    data() {
      return {
        hasElipsis: false
      }
    },
    methods: {
      wasParentLoaded() {
        let el = document.getElementById(this.element);
        if (!el) {
          setTimeout(() => {
            this.wasParentLoaded()
          }, 1000);
        } else {
          this.hasElipsis = el.offsetWidth < el.scrollWidth;
        }
      }
    },
    created() {
      this.wasParentLoaded();
    }
  }
</script>

<style scoped>
  b {
    font-weight: 600;
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/HasElipsis.vue